require('../../modules/es6.object.to-string');
module.exports = require('../../modules/_wks-ext').f('toStringTag');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/fn/symbol/to-string-tag.js
// module id = 96
// module chunks = 0